import React, { useMemo } from "react";
import { isNil, isString } from "lodash";

import CircleKpi from "./CircleKpi";
import DialKpi from "./DialKpi";
import ChartKpi from "./ChartKpi";
import CardKpi from "./CardKpi";

const DEFAULT_COLORS = ["#00b8a9", "#7471CA", "#FC427B", "#74b9ff"];

const KPI_TYPE_CIRCULAR = "circular";
const KPI_TYPE_DIAL = "dial";
const KPI_TYPE_CHART = "chart";
export const KPI_TYPE_CARD = "card";

const resolveKpi = (props) => ({
  [KPI_TYPE_CIRCULAR]: <CircleKpi {...props} />,
  [KPI_TYPE_DIAL]: <DialKpi {...props} />,
  [KPI_TYPE_CHART]: <ChartKpi {...props} />,
  [KPI_TYPE_CARD]: <CardKpi {...props} />,
});

function KpiResolver({ type, data, colors, ...other }) {
  const memoType = useMemo(() => {
    if (isNil(type) || type === "") {
      return KPI_TYPE_CIRCULAR;
    }

    if (isString(type) && type.toUpperCase().includes("CHART")) {
      return KPI_TYPE_CHART;
    }

    return type;
  }, [type]);

  return (
    <>
      {
        resolveKpi({
          data,
          colors: colors || DEFAULT_COLORS,
          ...other,
        })[memoType]
      }
    </>
  );
}

export default KpiResolver;
